import { useSelector, useDispatch } from "react-redux";
import {
  setActiveSection,
  setCurrentQuestionIndex,
} from "../../redux/exam/examSlice";
import "../tests/exam/components/SectionTabs.css";
import { useState, useMemo, useEffect, useRef } from "react";
import Sidebar from "../../shared/components/Sidebar/Sidebar";
import { getExamSectionKey } from "../../shared/utilities/helpers/examSectionKey";
import QuestionGrid from "../tests/exam/components/question/QuestionGrid/QuestionGrid";
import QuestionLegend from "../tests/exam/components/question/QuestionLegend/QuestionLegend";
import { useLocation } from "react-router-dom";

/**
 * Section tabs for Mistake Book test — advances index only.
 * Shared SectionTabs also dispatches fetchExamQuestionRequest on tab click,
 * which doubles with the parent alignment effect.
 */
export default function MistakeBookSectionTabs({ onSelectQuestion }) {
  const location = useLocation();
  const { questionsData, activeSection } = useSelector((s) => s.examSlice);
  const isAdaptiveMode = location?.state?.useAdaptiveTestScreen === true;
  const dispatch = useDispatch();
  const [_, setActiveQuestionId] = useState(null);

  const sidebarWidth = 400;
  const questionRefs = useRef({});

  const handleSelectQuestionInternal = (id) => {
    setActiveQuestionId(id);
    if (typeof onSelectQuestion === "function") {
      onSelectQuestion(id);
    }
  };

  const combinedSections = useMemo(() => {
    const unique = new Set();
    (questionsData || []).forEach((q) => {
      unique.add(getExamSectionKey(q));
    });
    return Array.from(unique);
  }, [questionsData]);

  useEffect(() => {
    if (!combinedSections.length) return;

    const currentQuestion = questionsData?.find((q) => q.status === "current");

    if (currentQuestion) {
      dispatch(setActiveSection(getExamSectionKey(currentQuestion)));
    } else if (!activeSection) {
      dispatch(setActiveSection(combinedSections[0]));
    }
  }, [questionsData, combinedSections, activeSection, dispatch]);

  const handleSectionClick = (sec) => {
    dispatch(setActiveSection(sec));

    const firstQuestion = questionsData?.find(
      (q) => getExamSectionKey(q) === sec
    );

    if (firstQuestion) {
      const firstIndex = questionsData.findIndex(
        (q) => q.qid === firstQuestion.qid
      );
      dispatch(setCurrentQuestionIndex(firstIndex));
      // Question payload loaded once by MistakeBookTestScreen alignment effect.
    }
  };

  return (
    <div className="section-tabs-wrapper">
      <div className="section-tabs">
        <div className="tabs-left">
          {combinedSections.map((sec) => (
            <div
              key={sec}
              className={`tab-item ${activeSection === sec ? "active" : ""}`}
              onClick={() => handleSectionClick(sec)}
            >
              {sec}
            </div>
          ))}
        </div>
      </div>

      {!isAdaptiveMode ? (
        <Sidebar
          width={`${sidebarWidth}px`}
          position="right"
          color="#000"
          padding="20px"
          boxShadow="-2px 0px 8px rgba(0,0,0,0.15)"
          offsetTop={90}
        >
          <QuestionLegend />
          <QuestionGrid
            onSelect={handleSelectQuestionInternal}
            registerRef={(sec, el) => {
              if (!questionRefs.current[sec]) {
                questionRefs.current[sec] = el;
              }
            }}
          />
        </Sidebar>
      ) : null}
    </div>
  );
}
